module.exports = __webpack_public_path__ + "img/icon-menu-delete.ceeb70cc.svg";